module.exports = __webpack_public_path__ + "static/media/profile.9561639a.svg";